export default class SalutationsConstants {
  static DR = 1

  static MISS = 2

  static MR = 3

  static MRS = 4

  static MS = 5

  static LADY = 28

  static LORD = 27

  static SIR = 31

  static MX = 30

  static PROFESSOR = 29

  static NOT_SPECIFIED = 16


  static salutations = [
    {
      salutation_id: SalutationsConstants.MR,
      name: 'Mr.',
    },
    {
      salutation_id: SalutationsConstants.MRS,
      name: 'Mrs.',
    },
    {
      salutation_id: SalutationsConstants.MISS,
      name: 'Miss',
    },
    {
      salutation_id: SalutationsConstants.MS,
      name: 'Ms.',
    },
    {
      salutation_id: SalutationsConstants.DR,
      name: 'Dr.',
    },
    {
      salutation_id: SalutationsConstants.LADY,
      name: 'Lady',
    },
    {
      salutation_id: SalutationsConstants.LORD,
      name: 'Lord',
    },
    {
      salutation_id: SalutationsConstants.SIR,
      name: 'Sir',
    },
    {
      salutation_id: SalutationsConstants.MX,
      name: 'Mx.',
    },
    {
      salutation_id: SalutationsConstants.PROFESSOR,
      name: 'Professor',
    },
    {
      salutation_id: SalutationsConstants.NOT_SPECIFIED,
      name: 'Not Specified',
    },
  ];

  static allSalutations = [
    {
      salutation_id: 3,
      name: 'Mr',
    },
    {
      salutation_id: 4,
      name: 'Mrs',
    },
    {
      salutation_id: 2,
      name: 'Miss',
    },
    {
      salutation_id: 5,
      name: 'Ms',
    },
    {
      salutation_id: 1,
      name: 'Dr',
    },
    {
      salutation_id: 28,
      name: 'Lady',
    },
    {
      salutation_id: 27,
      name: 'Lord',
    },
    {
      salutation_id: 31,
      name: 'Sir',
    },
    {
      salutation_id: 30,
      name: 'Mx',
    },
    {
      salutation_id: 29,
      name: 'Professor',
    },
    {
      salutation_id: 16,
      name: 'Not Specified',
    },
  ];
}
